const MIN_DISTANCE_IN_KM_HEALTH = '25';

export {MIN_DISTANCE_IN_KM_HEALTH};
